<template>
  <div class="home" :class="{ 'limit': $config.settings.onlayReg }">
    <v-floating-bar v-if="$store.state.config.hideElement" />
    <home-top-banner v-if="this.bannerList.length != 0" class="homeTopBanner" :option="bannerList"></home-top-banner>
    <template v-else>
      <div class="noBannerList"></div>
    </template>
    <div class="homeW homeStep" v-if="false">
      <img v-if="language == 'zh'"
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/home/stepCn.png" />
      <img v-else src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/home/stepEn.png" />
    </div>
    <homeBanner class="homeW homeBanner" v-if="this.carouselArr.length != 0" :option="carouselArr"></homeBanner>
    <home-data-show v-if="dataShow.length != 0" :dataShow="dataShow" class="homeW homeDataShow"></home-data-show>

    <div style="width:100%;background: #fff;margin-bottom: 32px;padding:24px 0;">
      <!-- 搜索栏 -->
      <v-search-input v-if="(subjectType == 'VISITOR' || subjectType == '')" key="v-search-input" />

      <div class="youLike" v-if="bannerHotIndustryList.length != 0">
        <homeHotIndustry class="homeW homeYouMayLike" :bannerHotIndustryList="bannerHotIndustryList"></homeHotIndustry>
      </div>
    </div>

    <!-- 展馆图 -->
    <div class="homeExhibitionHall homeW" style="margin-bottom: 24px;">
      <img class="pointer"
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/exhibition_hall_banner.png" />
    </div>

    <!-- 展位导航、观众预登记、展位预订 -->
    <div class="homeRegOrBook homeW" style="margin-bottom: 32px;">
      <img style="margin-bottom: 24px;" class="pointer"
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/booth_map_banner.png" />
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <img @click="goEzt3Login()" class="pointer"
            src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/visitor_reg_banner.png" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <img class="pointer"
            src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/book_stand_banner.png" />
        </el-col>
      </el-row>
    </div>

    <!-- 会议 -->
    <div class="homeMetting homeW" style="margin-bottom: 32px;">
      <img style="margin-bottom: 16px;" class="pointer"
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/meeting_banner.png" />
      <home-metting></home-metting>
    </div>
    <div class="homePhotoLive homeW" style="margin-bottom: 32px;">
      <img class="pointer" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/photo_live.png" />
    </div>
    <div class="homeFooter">
      <div class="homeW homeFooterBox">
        <home-footer v-if="$store.state.config.hideElement"></home-footer>
      </div>
    </div>
    <div class="limit_master" v-if="$config.settings.onlayReg" @click="noVisitorTodoAction"></div>
    <noticDialogChrome></noticDialogChrome>



    <!-- <div class="youLike" v-if="bannerOverseasChineseMerchantList.length != 0">
      <p class="homeTipsTitle">{{ $t('港澳台和海外侨商') }}</p>
      <homeOverseasChineseMerchant class="homeW homeYouMayLike"
        :bannerOverseasChineseMerchantList="bannerOverseasChineseMerchantList"></homeOverseasChineseMerchant>
    </div> -->



    <!-- <HomeHotExhibits class="homeW" /> -->
    <!-- <HomeNews /> -->
    <!-- <home3DFloorplanGuide class="homeW home3DFloorplanGuide"></home3DFloorplanGuide> -->
    <!-- <div class="Stream"
      v-if="(recordsList.length != 0 || recordsRecommendList.length != 0) && (subjectType == 'VISITOR' || subjectType == '')">
      <p class="homeTipsTitle">{{ $t('homes.liveStream') }}</p>
      <home-live-stream v-if="recordsList.length != 0 && (subjectType == 'VISITOR' || subjectType == '')"
        class="homeW homeLiveStream" :option="recordsList"></home-live-stream>
      <div class="homeW homeDivider"
        v-if="recordsRecommendList.length != 0 && (subjectType == 'VISITOR' || subjectType == '')"></div>
      <home-live-stream-list v-if="recordsRecommendList.length != 0 && (subjectType == 'VISITOR' || subjectType == '')"
        class="homeW homeLiveStreamList" :option="recordsRecommendList"></home-live-stream-list>
    </div>
    <homeBrandMuseum v-if="(subjectType == 'VISITOR' || subjectType == '')" class="homeBrandMuseum"
      :option="brandMuseumList"></homeBrandMuseum>
    <div class="youLike" v-if="youMayLike.length != 0 && (subjectType == 'VISITOR' || subjectType == '')">
      <p class="homeTipsTitle">{{ $t('homes.youMayLike') }}</p>
      <home-you-may-like class="homeW homeYouMayLike" :youMayLike="youMayLike"></home-you-may-like>
    </div>
    <!-- 推荐展商 s -->
    <home-featured-exhibitors @callback="recommendedExhibitors" :language="language"
      :exhFeatured="recomendExhibitorsData"
      v-if="(subjectType == 'VISITOR' || subjectType == '') && false"></home-featured-exhibitors>
    <div class="concurrent" v-if="concurrentEvents.length != 0">
      <p class="homeTipsTitle">{{ $t('homes.concurrentEvents') }}</p>
      <home-concurrent-events class="homeW homeConcurrentEvents"
        :concurrentEvents="concurrentEvents"></home-concurrent-events>
    </div>
  </div>
</template>

<script>
// import stepCn from '@/assets/homeImages/stepCn.png'
// import stepEn from '@/assets/homeImages/stepEn.png'

import face from '@/assets/homeImages/face.png'
import link from '@/assets/homeImages/link.png'
import ins from '@/assets/homeImages/ins.png'
import pin from '@/assets/homeImages/pin.png'
import tw from '@/assets/homeImages/tw.png'
import wechat from '@/assets/homeImages/wechat.png'
import downloadQRcode from '@/assets/homeImages/downloadQRcode.png'

import exhibitor from '@/assets/homeImages/exhibitor.png'
import person from '@/assets/homeImages/person.png'
import message from '@/assets/homeImages/message.png'
import goTop from '@/assets/homeImages/goTop.png'

import homeTopBanner from './index/indexTopBanner.vue'
import homeBanner from './index/indexBanner.vue'
import homeDataShow from './index/indexDataShow.vue'
// import HomeNews from './index/HomeNews'
// import HomeHotExhibits from './index/HomeHotExhibits'
// import home3DFloorplanGuide from './index/index3DFloorplanGuide.vue'
import homeLiveStream from './index/indexLiveStream.vue'
import homeLiveStreamList from './index/indexLiveStreamList.vue'
import homeBrandMuseum from './index/indexBrandMuseum.vue'

import homeFeaturedExhibitors from './index/indexFeaturedExhibitors.vue'
import homeYouMayLike from './index/indexYouMayLike.vue'
import homeConcurrentEvents from './index/indexConcurrentEvents.vue'

import homeFooter from './index/indexFooter.vue'

import homeHotIndustry from './index/indexHotIndustry.vue'
import homeOverseasChineseMerchant from './index/indexOverseasChineseMerchant.vue'

import FloatingBar from './index/FloatingBar.vue'

// 首页 会议
import homeMetting from './index/homeMetting.vue'
// 首页 搜索
import HomeSearchInput from './index/HomeSearchInput'


import noticDialogChrome from '@/components/dialog/noticDialogChrome.vue'
import TouristChat from '@/components/chat/TouristChat'
import '../styles/index.styl'

import { mapState, mapGetters } from 'vuex'
import {
  getConfigurationItemList,
  getRecommendProductList,
  getQueryList
} from '@/api/home'
import { getRecommendedExhibitorsList } from '@/api/find'
import {
  // allocationCustomerService, 
  getFetchList
} from '@/api'
import { getAuthCode } from '@/api/index'
export default {
  name: 'Home',
  components: {
    homeTopBanner,
    homeBanner,
    homeDataShow,
    // HomeHotExhibits,
    // home3DFloorplanGuide,
    homeLiveStream,
    homeLiveStreamList,
    homeBrandMuseum,
    homeFeaturedExhibitors,
    homeYouMayLike,
    homeConcurrentEvents,
    homeFooter,
    // HomeNews,
    noticDialogChrome,
    TouristChat,
    homeHotIndustry,
    homeOverseasChineseMerchant,
    'v-floating-bar': FloatingBar,
    homeMetting,
    'v-search-input': HomeSearchInput,
  },
  data() {
    return {
      // stepCn: stepCn,
      // stepEn: stepEn,
      face: face,
      link: link,
      ins: ins,
      pin: pin,
      tw: tw,
      wechat: wechat,
      downloadQRcode: downloadQRcode,
      exhibitor: exhibitor,
      person: person,
      message: message,
      goTop: goTop,
      carouselArr: [],
      dataShow: [],
      recordsList: [],
      brandMuseumList: [],
      recordsRecommendList: [],
      youMayLike: [],
      concurrentEvents: [],
      recomendExhibitorsData: [],
      bannerHotIndustryList: [],
      bannerOverseasChineseMerchantList: [],
      num: 1,
      bannerList: [],
      step: '',
    }
  },
  computed: {
    ...mapState(['onlineServices']),
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
  },
  metaInfo() {
    const isChinese = this.$store.getters.language !== 'en';
    
    if (isChinese) {
      return {
        title: 'CAC - 中国国际农用化学品及植保展览会',
        meta: [
          {
            name: 'description',
            content: '中国国际农用化学品及植保展览会,于 1999 年首次举办。第二十六届中国国际农用化学品及植保展览会（CAC2026）将在国家会展中心（上海）1.2 馆、2.2 馆、5.2 馆、6.2 馆、7.2 馆、8.2 馆举办,展出面积达到 16 万平方米。 CAC2026 展期将举办中国国际植保展览会（CropProtection）、中国国际新型肥料展览会（FSHOW）、中国国际农化装备及植保器械展览会（CACE）、中国国际现代农业科技展览会（AgTech）及 CAC 会议周（CACW）等分题展览及行业专题会议,届时将有 2,200 余家知名展商汇聚在农化的世界,与 100,000余人次的海内外业内人士共商世界的农化。'
          },
          {
            name: 'keywords',
            content: '植保器械展会,农药原药展会,农业机械展会,上海农化展览会,生物农药展会,农化装备展会,中国国际农药展,中国农药展会,最近农展会,中国(上海)国际农用化学品及植保展览会,助农展销会,农药展销会在哪里举办,农药展览,上海近期农展会,中国肥料展,农药中间体展会,农药展会,农药展销会,肥料展会,上海农化展会,中国农药展览会,中国农展会,上海农药原药展览会,上海农展会在什么地方,上海农资展会,国际农化展,上海农展会,上海农化展,农化展会,植保展会,农化展2026,2026上海农药展,近期农业展会,2026杭州农药展会,cac农化展2026,2026植保展,农业展会2026,2026上海农药展会,2026农展会,2026年农展会,农药展会2026时间表,农业展会2026时间表,2026年农资展览会,上海农药展会2026,上海农化展会2026,2026年农资展会时间表,2026年农业展会有哪些,2026植保展会,2026年农药展会,2026农化展,2026年农产品展会,农药展2026,2026农资展会,植保展,农展网,2026年全国农药展览会,农资展会,2026上海国际农药助剂展览会,2026年植保展会时间表,2026年农产品展览会,2026年农资展会,上海cac农化展,化肥展,北京农展会,上海国际农化展,2026年农药展会时间表,2026农药展览会,农展会,2026农药展,农资展览,全国农药展会,全国农业展会,青岛农药展会,农业展览馆近期展会,上海肥料展,上海肥料展会,国际农业展会,上海植保展,农展会信息,2026农产品展会,新型肥料展会,上海国际农化展cac,农资展览会,农资展销会,农化产品展,cac农药展2026,农展会2026年时间表格,2026农化展会,农业展会2026年,全国农药交流会暨农化产品展览会,上海植保展会,微生物农药研究进展,全国植保展,肥料展览会,国内农业展会,ace农药展会,中国国际肥料展览会,ace农药展,上海农药展,上海农药展会,上海原药展,cac农药展,农业设备展会,农业展销会博览会,农牧展会,农药助剂展,国际肥料展会,国际肥料展览会,cac农化展,农展馆最近展会,农化展,农药展览会,上海农药助剂展,农药展,cac上海农药展会,北京农展,农展,2026农药展会,全国农展会,全国农药交流会暨农化产品展览会,2026年中国农产品展览会,肥料展,农药国际展会,农药化肥展会,农用化学品（agrochemical）,农药（pesticide）,肥料（fertilizer）,植保（Crop protection）,herbicide (除草剂),insecticide （杀虫剂）,fungicide （杀菌剂）, biopesticide,Seed,specialty fertilizer (特种肥),npk（氮磷钾）,compound fertilizer（复合肥）'
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://cacizt-pc.eastfair.com/'
          }
        ]
      };
    } else {
      return {
        title: 'CAC - China International Agrochemical & Crop Protection Exhibition',
        meta: [
          {
            name: 'description',
            content: 'China International Agrochemical& Crop Protection Exhibition (CAC),was first launched in 1999. CAC2026 will be held at National Exhibition and Convention Center (Shanghai),at Halls 1.2,2.2,5.2,6.2,7.2 and 8.2,with a total exhibition space of 160,000 square meters. CAC2026 features several sub-exhibitions and industry conferences,including China International Crop Protection Exhibition(CropProtection),China International Fertilizer Show (FSHOW),China International Agrochemical & Crop Protection Equipment Exhibition(CACE),and China International AgTech Exhibition (AgTech),as well as CAC Conference Week (CACW). CAC2026 will bring together more than 2,200 leading exhibitors and over 100,000 attendance of industry professionals from home and abroad to explore globalagrochemical developments.'
          },
          {
            name: 'keywords',
            content: '植保器械展会,农药原药展会,农业机械展会,上海农化展览会,生物农药展会,农化装备展会,中国国际农药展,中国农药展会,最近农展会,中国(上海)国际农用化学品及植保展览会,助农展销会,农药展销会在哪里举办,农药展览,上海近期农展会,中国肥料展,农药中间体展会,农药展会,农药展销会,肥料展会,上海农化展会,中国农药展览会,中国农展会,上海农药原药展览会,上海农展会在什么地方,上海农资展会,国际农化展,上海农展会,上海农化展,农化展会,植保展会,农化展2026,2026上海农药展,近期农业展会,2026杭州农药展会,cac农化展2026,2026植保展,农业展会2026,2026上海农药展会,2026农展会,2026年农展会,农药展会2026时间表,农业展会2026时间表,2026年农资展览会,上海农药展会2026,上海农化展会2026,2026年农资展会时间表,2026年农业展会有哪些,2026植保展会,2026年农药展会,2026农化展,2026年农产品展会,农药展2026,2026农资展会,植保展,农展网,2026年全国农药展览会,农资展会,2026上海国际农药助剂展览会,2026年植保展会时间表,2026年农产品展览会,2026年农资展会,上海cac农化展,化肥展,北京农展会,上海国际农化展,2026年农药展会时间表,2026农药展览会,农展会,2026农药展,农资展览,全国农药展会,全国农业展会,青岛农药展会,农业展览馆近期展会,上海肥料展,上海肥料展会,国际农业展会,上海植保展,农展会信息,2026农产品展会,新型肥料展会,上海国际农化展cac,农资展览会,农资展销会,农化产品展,cac农药展2026,农展会2026年时间表格,2026农化展会,农业展会2026年,全国农药交流会暨农化产品展览会,上海植保展会,微生物农药研究进展,全国植保展,肥料展览会,国内农业展会,ace农药展会,中国国际肥料展览会,ace农药展,上海农药展,上海农药展会,上海原药展,cac农药展,农业设备展会,农业展销会博览会,农牧展会,农药助剂展,国际肥料展会,国际肥料展览会,cac农化展,农展馆最近展会,农化展,农药展览会,上海农药助剂展,农药展,cac上海农药展会,北京农展,农展,2026农药展会,全国农展会,全国农药交流会暨农化产品展览会,2026年中国农产品展览会,肥料展,农药国际展会,农药化肥展会,农用化学品（agrochemical）,农药（pesticide）,肥料（fertilizer）,植保（Crop protection）,herbicide (除草剂),insecticide （杀虫剂）,fungicide （杀菌剂）, biopesticide,Seed,specialty fertilizer (特种肥),npk（氮磷钾）,compound fertilizer（复合肥）'
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://cacizt-pc.eastfair.com/'
          }
        ]
      };
    }
  },
  methods: {
    // 跳转ezt3
    async goEzt3Login() {
      const authData = await getAuthCode()
      const data = authData.data
      if (data.code === 1000) {
        const authCode = data.data
        // 正式环境
        const target = `https://regcn.cacshow.com/#/jump?exhibitionId=1960598147339644930&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1965237171072868353&isOpenAdapt=yes&sourceCode=XCXen&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`

        // const target = `http://172.16.1.252:5173/#/jump?exhibitionId=1823536898857046018&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1823539766322335746&isOpenAdapt=yes&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`

        window.location.href = target
      }
    },
    // 排序
    sortSequence(a, b) {
      return a.sequence - b.sequence
    },
    // 回到顶部
    goTopScroll() {
      cancelAnimationFrame(timer)
      var timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop
        if (oTop > 0) {
          scrollBy(0, -50)
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
        }
      })
    },
    // 展商登录
    goExhibitor() {
      if (!this.ActorNoTodo()) return
      window.PC.$RangersEvent("Homepagesuspension_Exhibitors_Click")
      this.$store.commit('SET_SUBJECTTYPE', 'ACTOR')
      this.loginSource('/login/actor')
    },
    // 观众登录注册
    goPerson() {
      window.PC.$RangersEvent("Homepagesuspension_visitor_Click")
      this.$store.commit('SET_SUBJECTTYPE', 'VISITOR')
      this.loginSource('/login/person')
    },
    // 消息
    goMessage(item) {
      window.PC.$RangersEvent("Homepagesuspension_OnlineService_Click")
      item.position = this.$t('Online Service')
    },
    // 获取首页顶部bannner
    getHomeTopBannerList() {
      getConfigurationItemList({
        sourceType: 1
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            // 顶部轮播图
            if (res.data.bannerMap['PC_TOP_SWIPER_BANNER'] && res.data.bannerMap['PC_TOP_SWIPER_BANNER'].length != 0) {
              for (let i in res.data.bannerMap['PC_TOP_SWIPER_BANNER']) {
                console.log(res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'], "res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType']")
                if (res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'TAG_EXHIBITOR' || res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'ACTOR_DETAILS' || res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'TAG_PRODUCT') {
                  this.bannerList.push(res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i])
                }
              }
              this.bannerList.sort(this.sortSequence)
            }
            // 顶部轮播图下方图片
            if (res.data.bannerMap['HOMESTEP'] && res.data.bannerMap['HOMESTEP'].length != 0) {
              for (let i in res.data.bannerMap['HOMESTEP']) {
                if (res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'TAG_EXHIBITOR' || res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'ACTOR_DETAILS' || res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'TAG_PRODUCT') {
                  this.step = res.data.bannerMap['HOMESTEP'][0]['coverIcon'] || ''
                }
              }
            }
            // 轮播视频
            if (res.data.bannerMap['PC_SWIPER_VIDEO'] && res.data.bannerMap['PC_SWIPER_VIDEO'].length != 0) {
              var arr = []
              for (let i in res.data.bannerMap['PC_SWIPER_VIDEO']) {
                if (res.data.bannerMap['PC_SWIPER_VIDEO'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_SWIPER_VIDEO'][i]['urlType'] === 'PC_TOP_BANNER') {
                  arr.push(res.data.bannerMap['PC_SWIPER_VIDEO'][i])
                }
              }
              console.log(arr)
              if (arr.length > 0) {
                for (let i in arr) {
                  this.carouselArr.push({
                    'name': arr[i]['title'],
                    'picture': arr[i]['coverIcon'],
                    'type': arr[i]['urlType'],
                    'index': arr[i]['id'],
                    'externalLink': arr[i]['url'],
                    'url': arr[i]['videoUrl'],
                    'isImge': arr[i]['videoUrl'] ? false : true
                  })
                }
                this.carouselArr.sort(this.sortSequence)
              } else {
                this.carouselArr = []
              }


              // console.log(this.carouselArr)
            }

            // let data = res.data.bannerMap['HOME']
            // 腰部轮播图
            if (res.data.bannerMap['HOME'] && res.data.bannerMap['HOME'].length != 0) {
              for (let i in res.data.bannerMap['HOME']) {
                if (res.data.bannerMap['HOME'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['HOME'][i]['urlType'] === 'TAG_EXHIBITOR' || res.data.bannerMap['HOME'][i]['urlType'] === 'ACTOR_DETAILS' || res.data.bannerMap['HOME'][i]['urlType'] === 'TAG_PRODUCT') {
                  this.brandMuseumList.push(res.data.bannerMap['HOME'][i])
                }
              }
              this.brandMuseumList.sort(this.sortSequence)
            }
            console.log('this.brandMuseumList:', this.brandMuseumList)

            // 首页热门产业
            if (res.data.bannerMap['PC_HOME_HOT_INDUSTRY'] && res.data.bannerMap['PC_HOME_HOT_INDUSTRY'].length != 0) {
              for (let i in res.data.bannerMap['PC_HOME_HOT_INDUSTRY']) {
                if (
                  res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'EXTERNAL' ||
                  res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'TAG_EXHIBITOR' ||
                  res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'ACTOR_DETAILS' ||
                  res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'TAG_PRODUCT' ||
                  res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'PRODUCT_DETAILS' ||
                  res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'LIST_EXHIBITOR'
                ) {
                  this.bannerHotIndustryList.push(res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i])
                }
              }
              this.bannerHotIndustryList.sort(this.sortSequence)
            }

            console.log('this.bannerHotIndustryList:', this.bannerHotIndustryList)


            // 首页海外侨商
            if (res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'] && res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'].length != 0) {
              for (let i in res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT']) {
                if (res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'TAG_EXHIBITOR' || res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'ACTOR_DETAILS' || res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'TAG_PRODUCT' || res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'PRODUCT_DETAILS') {
                  this.bannerOverseasChineseMerchantList.push(res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i])
                }
              }
              this.bannerOverseasChineseMerchantList.sort(this.sortSequence)
            }
            console.log('this.bannerOverseasChineseMerchantList:', this.bannerOverseasChineseMerchantList)
          }
        })
    },
    // 获取首页展品列表
    getHomeProductList() {
      getRecommendProductList({
        showType: 'PRODUCT_LIST',
        productSort: "recommend_custom_letter_asc",
        pageNum: 1,
        pageRows: 10
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            this.youMayLike = res.data.list
          }
        })
    },
    // 获取首页 排序  列表
    getHomeQueryList(parms, type) {
      getQueryList(parms)
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            if (type == 'deprecated') {
              this.recordsList = res.data.records
            } else if (type == 'recommend') {
              this.recordsRecommendList = res.data.records
            } else if (type == 'host') {
              this.concurrentEvents = res.data.records
            }
          }
        })
    },
    // eslint-disable-next-line no-unused-vars
    //推荐展商
    recommendedExhibitors(param = {}) {
      const loading = this.$loading({
        lock: true,
      })
      getRecommendedExhibitorsList({
        showType: 'ACTOR_LIST',
        exhibitorSort: "recommend_custom_letter_asc",
        pageNum: 1,
        pageRows: 12
      }).then(res => {
        if (res.data.code == 1000) {
          let arr = res.data.data.list;
          arr = arr.length > 12 ? arr.splice(0, 12) : arr
          this.recomendExhibitorsData = arr
        }
      }).finally(() => {
        loading.close();
      })
    }
  },
  async mounted() {

    this.dataShow = this.$config.dataShow
    // 已登陆时，区分客商(VISITOR)与展商(ACTOR)
    // isLogin为true是已登录  为false是游客
    if (this.isLogin) {
      if (this.subjectType == 'VISITOR') {
        // 获取首页头部banner图
        this.getHomeTopBannerList()
        // 按时间排序 展商
        this.getHomeQueryList({ liveState: 0, liveParty: 2, orderDesc: 1 }, 'deprecated')
        // 按推荐排序 展商
        this.getHomeQueryList({ sponsorRecommendation: 1 }, 'recommend')
        // 主办 直播
        this.getHomeQueryList({ liveState: 0, liveParty: 1 }, 'host')
        // 获取推荐展品列表
        this.getHomeProductList()
      } else if (this.subjectType == 'ACTOR') {
        // 获取首页头部banner图
        this.getHomeTopBannerList()
        // 主办 直播
        this.getHomeQueryList({ liveState: 0, liveParty: 1 }, 'host')
      }
      // if (this.onlineServices.length === 0 && this.isLogin) {
      // TODO
      // allocationCustomerService({}).then(res => {
      //   this.$store.commit('setOnlineServices', res.data.data)
      // })
      await getFetchList({})
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            // res.data.config && this.$store.commit('setOnlineServiceTel', res.data.config.customServiceTelephone)
            this.$store.commit('SET_CONFIGSWITCH', res.data.configSwitch)
          }
        })
      // }
    } else {
      // 获取首页头部banner图
      this.getHomeTopBannerList()
      // 按时间排序 展商
      this.getHomeQueryList({ liveState: 0, liveParty: 2, orderDesc: 1 }, 'deprecated')
      // 按推荐排序 展商
      this.getHomeQueryList({ sponsorRecommendation: 1 }, 'recommend')
      // 主办 直播
      this.getHomeQueryList({ liveState: 0, liveParty: 1 }, 'host')
      // 获取推荐展品列表
      this.getHomeProductList()
    }

  },
  created() {
    this.recommendedExhibitors()
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/index'

.hide{
  display:none;
}
.Stream{
  width: 100%;
  max-height 1167px;
  background: $color-index-stream-bg url('../assets/homeImages/bg-events-img.png') no-repeat ;
  background-position-y: bottom ;
}
.concurrent{
  width: 100%;
  height 741px;
  background: $color-index-stream-bg url('../assets/homeImages/bg-events-img.png') no-repeat ;
  background-position-y: bottom ;
}
.homeFooter{
  .at4-visually-hidden{
    width 400px
    height 400px
  }
}
</style>

<style lang="stylus">
  .limit {
    .limit_master {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      z-index: 999;
    }

    .fixedLeft {
      z-index: 1002;
      background: $color-main;
    }

    .homeTopBanner,
    .homeBanner,
    .homeBrandMuseum {
      position relative;
      z-index: 1000;
    }

    .homeBanner {
      z-index: 1001;
    }

    .v-video-box .v-video-wrap {
      height: 60%;
    }
  }
</style>